import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCopy } from "@fortawesome/free-solid-svg-icons";
import { formatLocalizedDateTimeParts } from "../../utils/formatDateTime";

function CopyLink({ href, label, copyLabel, copiedLabel }) {
  const [copied, setCopied] = useState(false);
  if (!href) return <span className="trackhub-reports-mono">—</span>;

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(href);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Failed to copy payment link", err);
    }
  };

  return (
    <span className="trackhub-reports-payment" dir="ltr">
      <a
        className="trackhub-reports-payment__link"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {label}
      </a>
      <button
        type="button"
        className="trackhub-reports-payment__copy"
        onClick={handleCopy}
        aria-label={copied ? copiedLabel : copyLabel}
        title={copied ? copiedLabel : copyLabel}
      >
        <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
      </button>
    </span>
  );
}

function paymentWasSkipped(row) {
  const share = Number(row?.customerShare);
  return row?.coveredByBusiness === true && Number.isFinite(share) && share > 0;
}

export default function ShipmentPaymentCell({ row, t, dateLocale }) {
  const paid = row?.paymentStatus === "paid";
  const pending = !paid && (
    row?.paymentStatus === "pending_payment" || row?.status === "Pending Payment"
  );

  if (row?.paymentStatus === "skipped" || paymentWasSkipped(row)) {
    return <span className="trackhub-reports-mono">{t("shipmentsPage.paymentSkipped")}</span>;
  }

  if (!row?.paymentStatus && !row?.coveredByBusiness) {
    return <span className="trackhub-reports-mono">—</span>;
  }

  if (row?.coveredByBusiness) {
    return (
      <span className="trackhub-reports-mono">{t("shipmentsPage.coveredByBusiness")}</span>
    );
  }

  if (pending && row?.paymentLinkUrl) {
    const expires = row.paymentExpiresAt
      ? formatLocalizedDateTimeParts(row.paymentExpiresAt, dateLocale, { withSeconds: false })
      : null;
    return (
      <div className="trackhub-reports-payment-cell">
        <CopyLink
          href={row.paymentLinkUrl}
          label={t("shipmentsPage.paymentLink")}
          copyLabel={t("shipmentsPage.copyPaymentLink")}
          copiedLabel={t("shipmentsPage.paymentLinkCopied")}
        />
        {expires ? (
          <span className="trackhub-reports-payment__expiry" dir="ltr">
            {t("shipmentsPage.paymentExpires", {
              date: expires.date,
              time: expires.time,
            })}
          </span>
        ) : null}
      </div>
    );
  }

  if (paid && row?.invoiceUrl) {
    return (
      <CopyLink
        href={row.invoiceUrl}
        label={t("shipmentsPage.invoiceLink")}
        copyLabel={t("shipmentsPage.copyInvoiceLink")}
        copiedLabel={t("shipmentsPage.invoiceLinkCopied")}
      />
    );
  }

  if (paid) {
    return <span className="trackhub-reports-mono">{t("shipmentsPage.paid")}</span>;
  }

  return <span className="trackhub-reports-mono">—</span>;
}
